import React from 'react';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { useMutation } from 'react-fetching-library';
import { Modal, Card, CardContent, CardHeader, IconButton, Stack, Alert, Button, Portal, Typography, Input, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { submitCheckboxSectionAction } from '../../../../../../../services/request';

import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { SmallFormTextField } from '../../../../../../../components/small-fields/SmallFormTextField';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function CheckboxSectionForm({ open, handleClose, handleAddCheckboxSection, categories, rowData, officeView }) {
  const refInputFile = React.useRef(null);
  const [fileName, setFileName] = React.useState('');
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [category, setCategory] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const { loading, mutate } = useMutation(submitCheckboxSectionAction);

  const handleFileSelect = e => {
    if (refInputFile.current.files[0]) {
      setFileName(refInputFile.current.files[0].name);
    } else {
      setFileName(e.target.files[0].name);
    }

  };

  const handleSubmit = async () => {
    if (!_.isNil(refInputFile.current.files[0])) {
      const formData = new FormData();
      formData.append('file', refInputFile.current.files[0]);
      formData.append('file_name', refInputFile.current.files[0].name);
      formData.append('employee_application', rowData.id);
      formData.append('document_name', name);
      formData.append('file_description', description);
      if (category == 6) {
        // category 6 to INNE, więc nie ograniczamy do jednej sekcji
        formData.append('identifier', `${category}-${rowData.id}-${uuidv4()}`);
      } else {
        formData.append('identifier', `${category}-${rowData.id}`);
      }
      formData.append('category', category);
      formData.append('name', categories.find(c => c.value == category).label);
      if (officeView) {
        formData.append('section_type', 'dodatkowe dokumenty personalne dodane przez biuro');
      } else {
        formData.append('section_type', 'dodatkowe dokumenty personalne dodane przez pracownika');
      }
      formData.append('office_view', officeView);
      const { error, payload } = await mutate(formData);

      if (!error) {
        if (payload.message !== undefined) {
          setErrorMessage(payload.message);
        } else {
          handleAddCheckboxSection(payload);
          handleClose();
        }
      } else {
        setErrorMessage('Wystąpił błąd');
      }
    }
  };

  React.useEffect(() => {
    if (open === false) {
      setName('');
      setDescription('');
      setFileName('');
      setErrorMessage('');
      if (refInputFile.current != null) {
        refInputFile.current.value = null;
      }
    }
  }, [open]);

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader
            title="Dodaj dokument"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack spacing={3}>
              <SmallFormTextField
                name="name"
                placeholder="Nazwa dokumentu"
                value={name}
                sx={{ width: '100%' }}
                onChange={e => setName(e.target.value)}
              />
              <SmallFormTextField
                name="description"
                placeholder="Opis pliku"
                value={description}
                sx={{ width: '100%' }}
                onChange={e => setDescription(e.target.value)}
                multiline={true}
                rows={3}
              />
              <FormControl sx={{ minWidth: ' 200px' }}>
                <InputLabel variant="standard" htmlFor="uncontrolled-native">
                  Wybierz kategorię
                </InputLabel>
                <Select
                  sx={{ width: '100%' }}
                  placeholder="Wybierz kategorię"
                  variant="outlined"
                  labelId="category"
                  value={category}
                  defaultValue={null}
                  label="Kategoria"
                  onChange={e => setCategory(e.target.value)}
                >
                  {categories &&
                    categories.map(obj => (
                      <MenuItem key={obj.value} value={obj.value}>
                        {obj.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Stack direction="row" spacing={2} alignItems="center">
                <Button variant="contained" component="label" sx={{ textAlign: 'center' }}>
                  Wczytaj plik
                  <input type="file" hidden ref={refInputFile} onChange={handleFileSelect}/>
                </Button>
                {fileName !== ''
                  ? <Stack direction="row" spacing={1}>
                    <InsertDriveFileOutlinedIcon color="primary"/>
                    <Typography variant="subtitle2">{fileName}</Typography>
                  </Stack>
                  : null}
              </Stack>
              {errorMessage !== '' ? <Alert variant="outlined" severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert> : null}
              <Button variant="contained" fullWidth onClick={handleSubmit} disabled={loading || !category || !fileName}>zapisz</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
